const SPANISH_IBAN_FORMAT = /^ES\d{22}$/

export const normalizeIban = (value: string): string => {
    return value.replace(/[\s-]/g, '').toUpperCase()
}

/**
 * Validates a Spanish IBAN: format (ES + 22 digits) plus the standard
 * ISO 7064 mod-97 checksum, so transcription errors are caught too.
 */
export const isValidSpanishIban = (value: string): boolean => {
    const cleaned = normalizeIban(value)

    if (!SPANISH_IBAN_FORMAT.test(cleaned)) {
        return false
    }

    const rearranged = cleaned.slice(4) + cleaned.slice(0, 4)
    const numeric = rearranged.replace(/[A-Z]/g, (letter) => (letter.charCodeAt(0) - 55).toString())

    let remainder = 0
    for (let i = 0; i < numeric.length; i++) {
        remainder = (remainder * 10 + parseInt(numeric[i], 10)) % 97
    }

    return remainder === 1
}
